import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'LoginPage',
  components: { VueSlickCarousel },
  data() {
    return {
      login: '',
      password: '',
      hidePw: true,
      isFormValid: false,
      loginRules: {
        password: v => (v.length && v.length > 5) || 'Укажите пароль',
        phone: v => (v.length && v.length >= 17)
          || 'Номер телефона заполнен не полностью',
      },
      carouselSettings: {
        dots: true,
        arrows: false,
        dotsClass: 'slick-dots custom-dot-class',
        edgeFriction: 0.35,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
      },
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    isValid() {
      return this.login.length >= 17 && this.password.length > 5;
    },
  },
  methods: {
    async GoTo(event, path) {
      event.preventDefault();
      await this.$router.push(path);
    },
    Login() {
      const app = this;
      app.$store.getters.axl.post('api/login', { login: app.login, password: app.password })
        .then(async (response) => {
          await app.$store.dispatch('UserLogin', response.data);
          await app.$store.dispatch('GetProfile');
          await app.$router.push('/dashboard');
        });
    },
  },
  async mounted() {
    if (this.$store.state.settings.extranet === true) {
      await this.$router.push('/');
    }
  },
};
